import { featureToggles, isApp } from '@otto-ec/eprivacy-shared'
import { LOAD_CB_LAZY_TOGGLE } from './core'

if (!isApp() || !featureToggles('cb_no_load_in_app_context', false)) {
  const isLoadCbLazyEnabled = featureToggles(LOAD_CB_LAZY_TOGGLE, false)
  if (isLoadCbLazyEnabled) {
    void import('./bootstrap-lazy').then(({ bootstrapLazy }) => bootstrapLazy())
  } else {
    void import('./bootstrap').then(({ bootstrap }) => bootstrap())
  }
}
